import Priorat from './Priorat'

export default Priorat
